/**
 * Single source of truth for the @silk-hq/components license string.
 * Consumed by every <Sheet.Root license={SILK_LICENSE}> inside the
 * SilkSheet wrapper at src/components/ui/silk-sheet.tsx.
 *
 * Pre-mainnet release action (tracked in the mainnet release checklist;
 * no build-time gate per operator decision 2026-05-11, spec 095):
 * purchase the commercial license at https://silkhq.com/access and flip
 * "non-commercial" → "commercial".
 */
export const SILK_LICENSE = 'non-commercial' as const;

export type SilkLicense = typeof SILK_LICENSE | 'commercial';
